import { render, staticRenderFns } from "./BiotimeAreaList.vue?vue&type=template&id=6504ab7c&scoped=true&"
import script from "./BiotimeAreaList.vue?vue&type=script&lang=js&"
export * from "./BiotimeAreaList.vue?vue&type=script&lang=js&"
import style0 from "./BiotimeAreaList.vue?vue&type=style&index=0&id=6504ab7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6504ab7c",
  null
  
)

export default component.exports